export interface EnvironmentConfig {
  apiUrls: string[];
  environment: 'development' | 'production';
  timeout: number;
  retryAttempts: number;
}

/** Same license / backend base as apiService.js — prefer .env REACT_APP_LICENSE_API_BASE, then runtime override. */
function resolveLicenseApiBase(): string {
  const fromEnv =
    typeof process !== 'undefined' && process.env && process.env.REACT_APP_LICENSE_API_BASE
      ? String(process.env.REACT_APP_LICENSE_API_BASE).replace(/\/$/, '')
      : '';
  const fromStorage =
    typeof localStorage !== 'undefined' ? localStorage.getItem('gs_api_base') || '' : '';
  const fallback = 'https://script.google.com/macros/s/YOUR_DEPLOYMENT_ID/exec';
  return (fromEnv || fromStorage || fallback).replace(/\/$/, '');
}

const developmentConfig: EnvironmentConfig = {
  apiUrls: [resolveLicenseApiBase()],
  environment: 'development',
  timeout: 10000,
  retryAttempts: 3
};

const productionConfig: EnvironmentConfig = {
  apiUrls: [resolveLicenseApiBase()],
  environment: 'production',
  timeout: 15000,
  retryAttempts: 5
};

export const getEnvironmentConfig = (): EnvironmentConfig => {
  // Use process.env.NODE_ENV to detect development vs production
  // __DEV__ is React Native specific, so we use NODE_ENV for web/Electron
  const isDevelopment = process.env.NODE_ENV === 'development';
  return isDevelopment ? developmentConfig : productionConfig;
};

export const isProduction = (): boolean => {
  return process.env.NODE_ENV === 'production';
};
